/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEligibilityResult } from "./AccessEligibilityResult";

/**
 * What CMS decided about the patient's eligibility for a track.
 */
export interface AccessEligibilityResultModel {
  code: AccessEligibilityResult;
  text?: string | null;
  eligible: boolean;
}
